const bridge = () => typeof window !== "undefined" ? window.desktopOfflineInventory : null;
const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline Inventory.");
  return api;
};

const cleanInventoryError = (error) => {
  const message = String(error?.message || error || "Offline inventory operation failed.")
    .replace(/^Error invoking remote method '[^']+':\s*(?:Error:\s*)?/i, "")
    .replace(/^Error:\s*/i, "")
    .trim();
  const cleanError = new Error(message || "Offline inventory operation failed.");
  cleanError.cause = error;
  return cleanError;
};

const invoke = async (operation) => {
  try {
    return await operation();
  } catch (error) {
    throw cleanInventoryError(error);
  }
};

export const listOfflineInventoryItems = (restaurantId, filters = {}) =>
  invoke(() => requireBridge().listItems({ restaurantId, ...filters }));
export const saveOfflineInventoryItem = (restaurantId, item, itemId = null) =>
  invoke(() => requireBridge().saveItem({ restaurantId, itemId, ...item }));
export const saveOfflineStockIn = (payload) =>
  invoke(() => requireBridge().stockIn(payload));
export const saveOfflineStockOut = (payload) =>
  invoke(() => requireBridge().stockOut(payload));
export const listOfflineInventoryEntries = (restaurantId, type, filters = {}) =>
  invoke(() => requireBridge().listEntries({ restaurantId, type, ...filters }));
export const updateOfflineInventoryEntry = (restaurantId, type, entryId, changes) =>
  invoke(() => requireBridge().updateEntry({ restaurantId, type, entryId, ...changes }));
export const deleteOfflineInventoryEntry = (restaurantId, type, entryId) =>
  invoke(() => requireBridge().deleteEntry({ restaurantId, type, entryId }));
export const getOfflineInventorySummary = (restaurantId, date) =>
  invoke(() => requireBridge().summary({ restaurantId, date }));
export const getOfflineInventoryLedger = (restaurantId, itemId, from, to) =>
  invoke(() => requireBridge().ledger({ restaurantId, itemId, from, to }));
export const getOfflineInventoryStockSummaryReport = (restaurantId, date) =>
  invoke(() => requireBridge().stockSummaryReport({ restaurantId, date }));
export const getOfflineInventoryDailyUsageReport = (restaurantId, date) =>
  invoke(() => requireBridge().dailyUsageReport({ restaurantId, date }));
export const getOfflineInventoryLowStockReport = (restaurantId) =>
  invoke(() => requireBridge().lowStockReport({ restaurantId, onlyActive: true }));
export const getOfflineInventoryItemPerformanceReport = (
  restaurantId,
  from,
  to,
  sort,
  limit = 100
) => invoke(() => requireBridge().itemPerformanceReport({
  restaurantId, from, to, sort, limit,
}));
